import { render, staticRenderFns } from "./_conversationBody.vue?vue&type=template&id=365ce5dc"
import script from "./_conversationBody.vue?vue&type=script&lang=js"
export * from "./_conversationBody.vue?vue&type=script&lang=js"
import style0 from "./_conversationBody.vue?vue&type=style&index=0&id=365ce5dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports